export default __webpack_public_path__ + "static/media/ImageCard.e371d7ec.svg";